import { render } from "./Support.html?vue&type=template&id=e6ecf018&scoped=true&ts=true&external"
import script from "./Support.ts?vue&type=script&lang=ts&external"
export * from "./Support.ts?vue&type=script&lang=ts&external"

import "./Support.css?vue&type=style&index=0&id=e6ecf018&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6ecf018"]])

export default __exports__